import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslatePipe } from '@ngx-translate/core';

interface SnackbarData {
    message: string;
    type: 'success' | 'error' | 'warning';
}

@Component({
    selector: 'pims-snackbar',
    imports: [TranslatePipe],
    templateUrl: './snackbar.component.html',
    styleUrl: './snackbar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
    private readonly data = inject<SnackbarData>(MAT_SNACK_BAR_DATA);

    readonly message = this.data.message;
    readonly type = this.data.type;
}
